import { render, staticRenderFns } from "./QAeditor.vue?vue&type=template&id=3f4493b3&scoped=true"
import script from "./QAeditor.vue?vue&type=script&lang=js"
export * from "./QAeditor.vue?vue&type=script&lang=js"
import style0 from "./QAeditor.vue?vue&type=style&index=0&id=3f4493b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4493b3",
  null
  
)

export default component.exports